import { useContext, useEffect, useState } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Swal from 'sweetalert2';
import { refeshPend } from "../../../App";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";


function ScanbyManifest() {

    const [getData, setGetData] = useState([]);
    const [openRow, setOpenRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const { hub } = useContext(refeshPend);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return `${String(d.getDate()).padStart(2, "0")}/${String(
            d.getMonth() + 1
        ).padStart(2, "0")}/${d.getFullYear()}`;
    };
  

    const fetchData = async () => {
        try {
            const response = await getApi(`/Inscan/viewInscanData?SessionLocationCode=${JSON.parse(localStorage.getItem("Login"))?.Branch_Code}&pageNumber=${currentPage}&pageSize=${rowsPerPage}`);
            const currentPageData = Array.isArray(response.data) ? response.data : [];
            setGetData(currentPageData);
            setTotalRecords(response.Count);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            console.log('error')
        }
    };
    useEffect(() => {
        fetchData();
    }, [currentPage, rowsPerPage, hub]);

    const handleDelete = async (DocketNo,Branch_Code) => {
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this Inscan?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (confirmDelete.isConfirmed) {
            try {
                await postApi(`/Inscan/deleteInscan?DocketNo=${DocketNo}&SessionLocationCode=${Branch_Code}`);
                setGetData(getData.filter((inscan) => inscan.DocketNo !== DocketNo));
                Swal.fire('Deleted!', 'The Inscan has been deleted.', 'success');
                await fetchData();
            } catch (err) {
                console.error('Delete Error:', err);
                Swal.fire('Error', 'Failed to delete Inscan', 'error');
            }
        }
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    return (
        <>

            <div className="container1">

                <div className="table-container" style={{whiteSpace:"nowrap"}}>
                    <table className="table table-bordered table-sm">
                        <thead>
                            
                                <tr>
                                <th >Action</th>
                                <th >Sr.No</th>
                                <th >Branch.Code</th>
                                <th >Branch.Name</th>
                                <th >Docket.No</th>
                                <th >Booking.Date</th>
                                <th >Customer.Name</th>
                                <th >Consignee.Name</th>
                                <th >From.City</th>
                                <th >To.City</th>
                                <th >Manifest.No</th>
                                <th >Manifest.Date</th>
                                <th >QTY</th>
                                <th >Inscan.Status</th>
                                <th >Inscan.Remark</th>
                            </tr>
                           
                        </thead>

                        <tbody>
                            {getData.map((inscan, index) => (
                                <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                    <td>
                                        <PiDotsThreeOutlineVerticalFill
                                            style={{ fontSize: "20px", cursor: "pointer" }}
                                            onClick={() =>
                                                setOpenRow(openRow === index ? null : index) // toggle only this row
                                            }
                                        />

                                        {openRow === index && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    flexDirection: "row",
                                                    position: "absolute",
                                                    alignItems: "center",
                                                    left: "60px",
                                                    top: "0px",
                                                    borderRadius: "10px",
                                                    backgroundColor: "white",
                                                    zIndex: "999999",
                                                    height: "30px",
                                                    width: "50px",
                                                    padding: "10px"
                                                }}
                                            >
                                                <button className="edit-btn" onClick={() => handleDelete(inscan.DocketNo,inscan.SessionLocationCode)}>
                                                <i className='bi bi-trash' style={{ fontSize: "18px" }}></i>
                                            </button>
                                            </div>
                                        )}
                                    </td>
                                    <td>{index + 1}</td>
                                    <td>{inscan.SessionLocationCode}</td>
                                    <td>{inscan.ToDest}</td>
                                    <td>{inscan.DocketNo}</td>
                                    <td>{inscan.Bookdate}</td>
                                    <td>{inscan.Customer_Name}</td>
                                    <td>{inscan.ConsigneeName}</td>
                                    <td>{inscan.FromDest}</td>
                                    <td>{inscan.ToDest}</td>
                                    <td>{inscan.ManifestNo}</td>
                                    <td>{inscan.ManifestDt}</td>
                                    <td>{inscan.qty}</td>
                                    <td>{inscan.InscanStatus}</td>
                                    <td>{inscan.InscanRemark}</td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div style={{ display: "flex", flexDirection: "row", padding: "10px" }}>
                    <div className="pagination">
                        <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                            {'<'}
                        </button>
                        <span style={{ color: "#333", padding: "5px" }}>Page {currentPage} of {totalPages}</span>
                        <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                            {'>'}
                        </button>
                    </div>

                    <div className="rows-per-page" style={{ display: "flex", flexDirection: "row", color: "black", marginLeft: "10px" }}>
                        <label htmlFor="rowsPerPage" style={{ marginTop: "16px", marginRight: "10px" }}>Rows per page:</label>
                        <select
                            style={{ height: "40px", width: "60px", marginTop: "10px" }}
                            id="rowsPerPage"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ScanbyManifest;